// @ts-check
import { Features } from '../constants/features';
import { useIsSellerOnFeatureGatedPlan } from './use-is-seller-on-feature-gated-plan';
import { useIsEnhancedReturnsFeatureEnabled } from '../store/returns/returns.helpers';
import { useIsFeatureIncludedInAnyBillingPlan } from '../pages/settings/payment-and-subscription/hooks/use-plan-details';

/**
 * Should the standard return portal configuration be available for this merchant's
 * stores that support enhanced returns?
 * @returns {boolean}
 */
export const useShowStandardReturnsPortalForEnhancedStoreFeatureGate = () => {
  const isSellerOnFeatureGatedPlan = useIsSellerOnFeatureGatedPlan();
  const isEnhancedReturnsFeatureEnabled = useIsEnhancedReturnsFeatureEnabled();
  const isEnhancedReturnsAvailableOnAnyPlan = useIsFeatureIncludedInAnyBillingPlan(Features.EnhancedReturns);

  // we don't want to allow new plans to use standard returns for Shopify stores
  if (isSellerOnFeatureGatedPlan) {
    // fallback to showing standard returns if enhanced returns is not available
    // and not enabled for this seller (e.g. non-supported regions like UK on GBB)
    const shouldFallbackToLegacyReturns = !isEnhancedReturnsAvailableOnAnyPlan && !isEnhancedReturnsFeatureEnabled;
    return shouldFallbackToLegacyReturns;
  }

  return true;
};
